import { useHCaptchaStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/HCaptchaStore";
import { isNotUndefined } from "@faire/typescript";
import { useMutation as usePostHCaptchaMutation } from "@faire/web-api--source/endpoints/www/api/v2/users/retailer/hcaptcha/post-hooks";
import { ILoginRequest } from "@faire/web-api--source/indigofair/data/ILoginRequest";
import { ISubmitHCaptchaDataRequest } from "@faire/web-api--source/indigofair/data/ISubmitHCaptchaDataRequest";
import { logError } from "@faire/web/common/logging";
import { useCallback } from "react";

import { usePrecheckSession } from "./usePrecheckSession";

/**
 * Posts hCaptcha token to the backend, making the session trustworthy.
 */
export const usePostHCaptchaToBE = () => {
  const [{ submittedTokens }, setHCaptchaStore] = useHCaptchaStore([
    "submittedTokens",
  ]);
  const { mutateAsync: postHCaptcha } = usePostHCaptchaMutation();
  const { refetch: refetchPrecheckSession } = usePrecheckSession();

  const postHCaptchaToBE = useCallback(
    async (
      shouldPostTokenToBackend: boolean,
      data: ILoginRequest.IHCaptchaData
    ) => {
      if (
        shouldPostTokenToBackend &&
        !submittedTokens.includes(data.token ?? "")
      ) {
        try {
          await postHCaptcha([
            ISubmitHCaptchaDataRequest.build({ h_captcha_data: data }),
          ]);
          await refetchPrecheckSession();
          setHCaptchaStore((stale) => ({
            ...stale,
            submittedTokens: [...stale.submittedTokens, data.token].filter(
              isNotUndefined
            ),
          }));
        } catch (error) {
          logError(error);
        }
      }
    },
    [postHCaptcha, setHCaptchaStore, submittedTokens, refetchPrecheckSession]
  );

  return { postHCaptchaToBE };
};
